import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class Cache {
    private readonly _cache: Record<string, unknown>;

    constructor() {
        this._cache = {};
    }

    public async getValue<T>(key: string, asyncGetter: () => Promise<T>): Promise<T> {
        if (!Object.prototype.hasOwnProperty.call(this._cache, key)) {
            console.log('cache not done: ', key);
            this.putValue(key, await asyncGetter());
        } else {
            console.log('cache done: ', key);
        }
        return this._cache[key] as T;
    }

    public putValue<T>(key: string, value: T): void {
        this._cache[key] = value;

        const length = Object.getOwnPropertyNames(this._cache).length;
        if (length > 30) {
            console.warn('Pb on cache size exceed ? do a restart ?', length);
        }
    }
}
